import { useI18n } from "../i18n/useI18n";

type Props = {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
};

export function EstimatorForm({ value, onChange, onSubmit }: Props) {
  const { t } = useI18n();

  return (
    <div className="form-wrap">
      <h2>{t("form.title")}</h2>
      <p className="hint">{t("form.hint")}</p>
      <textarea
        className="textarea"
        rows={10}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        spellCheck={false}
      />
      <button type="button" className="primary" onClick={onSubmit}>
        {t("form.submit")}
      </button>

      <style>{`
        .form-wrap h2 {
          font-size: 1rem;
          margin: 0 0 0.35rem;
        }
        .hint {
          margin: 0 0 0.75rem;
          font-size: 0.85rem;
          color: var(--muted);
        }
        .textarea {
          width: 100%;
          resize: vertical;
          min-height: 220px;
          padding: 0.85rem 1rem;
          border-radius: 10px;
          border: 1px solid var(--border);
          background: var(--surface2);
          color: var(--text);
          margin-bottom: 0.75rem;
          font-family: var(--mono);
          font-size: 0.8rem;
          line-height: 1.45;
          box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.18);
        }
        .textarea:focus-visible {
          outline: none;
          border-color: var(--accent-dim);
          box-shadow:
            inset 0 2px 6px rgba(0, 0, 0, 0.18),
            0 0 0 2px var(--accent-chip);
        }
        .primary {
          border: none;
          background: linear-gradient(165deg, var(--accent) 0%, var(--accent-dim) 100%);
          color: #1a1408;
          font-weight: 600;
          padding: 0.55rem 1.1rem;
          border-radius: 8px;
          cursor: pointer;
        }
        .primary:hover {
          filter: brightness(1.05);
        }
        @media (max-width: 720px) {
          .textarea {
            font-size: 1rem;
            min-height: 200px;
          }
          .primary {
            width: 100%;
            min-height: 48px;
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
}
